"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.HealthCheckHarmonizationManager = void 0;
require("@veeam/core");
require("../../core");
const helpers_1 = require("./helpers");
const ScheduleHarmonizationManager_1 = require("./ScheduleHarmonizationManager");
const types_1 = require("./types");
class HealthCheckHarmonizationManager extends ScheduleHarmonizationManager_1.ScheduleHarmonizationManager {
    constructor(mainModel, models) {
        super(models);
        this.mainModel = mainModel;
        this.models = models;
        this.isAvailable = (isBackupEnabled) => {
            const dailyScheduleModelValue = this.models.dailyScheduleModel.getValue();
            const weeklyScheduleModelValue = this.models.weeklyScheduleModel.getValue();
            const monthlyScheduleModelValue = this.models.monthlyScheduleModel.getValue();
            const yearlyScheduleModelValue = this.models.yearlyScheduleModel.getValue();
            return HealthCheckHarmonizationManager.isAvailable(isBackupEnabled, dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue, yearlyScheduleModelValue);
        };
        this.getDayNumberInMonthData = () => {
            const dailyScheduleModelValue = this.models.dailyScheduleModel.getValue();
            const weeklyScheduleModelValue = this.models.weeklyScheduleModel.getValue();
            const monthlyScheduleModelValue = this.models.monthlyScheduleModel.getValue();
            const yearlyScheduleModelValue = this.models.yearlyScheduleModel.getValue();
            return HealthCheckHarmonizationManager.getDayNumberInMonthData(dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue, yearlyScheduleModelValue);
        };
        this.getDayOfMonthData = () => {
            const dailyScheduleModelValue = this.getDailyScheduleModelValue();
            const weeklyScheduleModelValue = this.getWeeklyScheduleModelValue();
            const monthlyScheduleModelValue = this.getMonthlyScheduleModelValue();
            const yearlyScheduleModelValue = this.getYearlyScheduleModelValue();
            return HealthCheckHarmonizationManager.getDayOfMonthData(dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue, yearlyScheduleModelValue);
        };
        this.getDayOfWeekData = () => {
            const modelValue = this.mainModel.getValue();
            const dailyScheduleModelValue = this.getDailyScheduleModelValue();
            const weeklyScheduleModelValue = this.getWeeklyScheduleModelValue();
            const monthlyScheduleModelValue = this.getMonthlyScheduleModelValue();
            const yearlyScheduleModelValue = this.getYearlyScheduleModelValue();
            return HealthCheckHarmonizationManager.getDayOfWeekData(modelValue, dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue, yearlyScheduleModelValue);
        };
        this.getMonthsData = () => {
            const dailyScheduleModelValue = this.getDailyScheduleModelValue();
            const weeklyScheduleModelValue = this.getWeeklyScheduleModelValue();
            const monthlyScheduleModelValue = this.getMonthlyScheduleModelValue();
            const yearlyScheduleModelValue = this.getYearlyScheduleModelValue();
            return HealthCheckHarmonizationManager.getMonthsData(dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue, yearlyScheduleModelValue);
        };
        this.isDayOfWeekControlVisible = () => {
            const modelValue = this.mainModel.getValue();
            const dailyScheduleModelValue = this.getDailyScheduleModelValue();
            const weeklyScheduleModelValue = this.getWeeklyScheduleModelValue();
            const monthlyScheduleModelValue = this.getMonthlyScheduleModelValue();
            const yearlyScheduleModelValue = this.getYearlyScheduleModelValue();
            return HealthCheckHarmonizationManager.isDayOfWeekControlVisible(modelValue, dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue, yearlyScheduleModelValue);
        };
        this.isDayOfMonthControlVisible = () => {
            const modelValue = this.mainModel.getValue();
            const dailyScheduleModelValue = this.getDailyScheduleModelValue();
            const weeklyScheduleModelValue = this.getWeeklyScheduleModelValue();
            const monthlyScheduleModelValue = this.getMonthlyScheduleModelValue();
            const yearlyScheduleModelValue = this.getYearlyScheduleModelValue();
            return HealthCheckHarmonizationManager.isDayOfMonthControlVisible(modelValue, dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue, yearlyScheduleModelValue);
        };
        this.isMonthSelectable = () => {
            const modelValue = this.mainModel.getValue();
            const dailyScheduleModelValue = this.getDailyScheduleModelValue();
            const weeklyScheduleModelValue = this.getWeeklyScheduleModelValue();
            const monthlyScheduleModelValue = this.getMonthlyScheduleModelValue();
            const yearlyScheduleModelValue = this.getYearlyScheduleModelValue();
            const isDailyScheduleEnabled = dailyScheduleModelValue.isEnabled &&
                helpers_1.isAnyScheduleUnitConfigured(dailyScheduleModelValue.rows.third.schedule);
            const isWeeklyScheduleEnabled = weeklyScheduleModelValue.isEnabled &&
                helpers_1.isAnyScheduleUnitConfigured(weeklyScheduleModelValue.rows.third.schedule);
            const isMonthlyScheduleEnabled = monthlyScheduleModelValue.isEnabled &&
                helpers_1.isAnyScheduleUnitConfigured(monthlyScheduleModelValue.rows.third.schedule);
            const isYearlyScheduleEnabled = yearlyScheduleModelValue.isEnabled;
            if (!modelValue.fieldMonthValue) {
                return false;
            }
            if (!isDailyScheduleEnabled &&
                !isWeeklyScheduleEnabled &&
                !isMonthlyScheduleEnabled &&
                isYearlyScheduleEnabled) {
                return true;
            }
            return false;
        };
        this.mainModel = mainModel;
        this.models = models;
    }
}
exports.HealthCheckHarmonizationManager = HealthCheckHarmonizationManager;
HealthCheckHarmonizationManager.getMainModelInitialValue = () => {
    return {
        isEnabled: false,
        isModified: false,
        fieldDayNumberInMonthValue: types_1.HEALTH_CHECK_DAY_NUMBER_IN_MONTH.first,
        fieldDayOfWeekValue: ScheduleHarmonizationManager_1.ScheduleHarmonizationManager.FIELD_DAY_OF_WEEK,
        fieldDayOfMonthValue: ScheduleHarmonizationManager_1.ScheduleHarmonizationManager.FIELD_DAY_OF_MONTH,
        fieldMonthValue: types_1.MONTH_OF_YEAR.january,
    };
};
HealthCheckHarmonizationManager.isAvailable = (isBackupEnabled, dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue, yearlyScheduleModelValue) => {
    const isDailyScheduleEnabled = dailyScheduleModelValue.isEnabled &&
        helpers_1.isAnyScheduleUnitConfigured(dailyScheduleModelValue.rows.third.schedule);
    const isWeeklyScheduleEnabled = weeklyScheduleModelValue.isEnabled &&
        helpers_1.isAnyScheduleUnitConfigured(weeklyScheduleModelValue.rows.third.schedule);
    const isMonthlyScheduleEnabled = monthlyScheduleModelValue.isEnabled &&
        helpers_1.isAnyScheduleUnitConfigured(monthlyScheduleModelValue.rows.third.schedule);
    if (!isBackupEnabled ||
        (!dailyScheduleModelValue.isEnabled &&
            !weeklyScheduleModelValue.isEnabled &&
            !monthlyScheduleModelValue.isEnabled &&
            !yearlyScheduleModelValue.isEnabled)) {
        return false;
    }
    return (isDailyScheduleEnabled ||
        isWeeklyScheduleEnabled ||
        isMonthlyScheduleEnabled ||
        yearlyScheduleModelValue.isEnabled);
};
HealthCheckHarmonizationManager.getDayNumberInMonthList = () => {
    return [
        types_1.HEALTH_CHECK_DAY_NUMBER_IN_MONTH.first,
        types_1.HEALTH_CHECK_DAY_NUMBER_IN_MONTH.second,
        types_1.HEALTH_CHECK_DAY_NUMBER_IN_MONTH.third,
        types_1.HEALTH_CHECK_DAY_NUMBER_IN_MONTH.fourth,
        types_1.HEALTH_CHECK_DAY_NUMBER_IN_MONTH.last,
        types_1.HEALTH_CHECK_DAY_NUMBER_IN_MONTH.every,
    ];
};
HealthCheckHarmonizationManager.getDayNumberInMonthData = (dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue, yearlyScheduleModelValue) => {
    let data = HealthCheckHarmonizationManager.getDayNumberInMonthList();
    const isDailyScheduleEnabled = dailyScheduleModelValue.isEnabled &&
        helpers_1.isAnyScheduleUnitConfigured(dailyScheduleModelValue.rows.third.schedule);
    const isWeeklyScheduleEnabled = weeklyScheduleModelValue.isEnabled &&
        helpers_1.isAnyScheduleUnitConfigured(weeklyScheduleModelValue.rows.third.schedule);
    const isMonthlyScheduleEnabled = monthlyScheduleModelValue.isEnabled &&
        helpers_1.isAnyScheduleUnitConfigured(monthlyScheduleModelValue.rows.third.schedule);
    const isYearlyScheduleEnabled = yearlyScheduleModelValue.isEnabled;
    if (!isDailyScheduleEnabled && !isWeeklyScheduleEnabled && isMonthlyScheduleEnabled) {
        if (monthlyScheduleModelValue.fields.dayNumberInMonth === types_1.DAY_NUMBER_IN_MONTH.onDay) {
            return [types_1.DAY_NUMBER_IN_MONTH.onDay];
        }
        else {
            const dayNumberInMonth = monthlyScheduleModelValue.fields.dayNumberInMonth;
            return [dayNumberInMonth];
        }
    }
    if (!isDailyScheduleEnabled &&
        !isWeeklyScheduleEnabled &&
        !isMonthlyScheduleEnabled &&
        isYearlyScheduleEnabled) {
        return [yearlyScheduleModelValue.fields.dayNumberInMonth];
    }
    return data;
};
HealthCheckHarmonizationManager.getDayOfMonthData = (dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue, yearlyScheduleModelValue) => {
    const isDailyScheduleEnabled = dailyScheduleModelValue.isEnabled &&
        helpers_1.isAnyScheduleUnitConfigured(dailyScheduleModelValue.rows.third.schedule);
    const isWeeklyScheduleEnabled = weeklyScheduleModelValue.isEnabled &&
        helpers_1.isAnyScheduleUnitConfigured(weeklyScheduleModelValue.rows.third.schedule);
    const isMonthlyScheduleEnabled = monthlyScheduleModelValue.isEnabled &&
        helpers_1.isAnyScheduleUnitConfigured(monthlyScheduleModelValue.rows.third.schedule);
    const isYearlyScheduleEnabled = yearlyScheduleModelValue.isEnabled;
    if (!isDailyScheduleEnabled &&
        !isWeeklyScheduleEnabled &&
        !isMonthlyScheduleEnabled &&
        isYearlyScheduleEnabled) {
        const yearlyDayOfMonth = yearlyScheduleModelValue.fields.dayOfMonth;
        return helpers_1.getDayOfMonthList(types_1.MONTH_OF_YEAR.january).filter((item) => item.id === yearlyDayOfMonth);
    }
    if (!isDailyScheduleEnabled && !isWeeklyScheduleEnabled && isMonthlyScheduleEnabled) {
        const monthlyDayOfMonth = monthlyScheduleModelValue.fields.dayOfMonth;
        return helpers_1.getDayOfMonthList(types_1.MONTH_OF_YEAR.january).filter((item) => item.id === monthlyDayOfMonth);
    }
    return helpers_1.getDayOfMonthList(types_1.MONTH_OF_YEAR.january);
};
HealthCheckHarmonizationManager.getDayOfWeekData = (modelValue, dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue, yearlyScheduleModelValue) => {
    const isDailyScheduleEnabled = dailyScheduleModelValue.isEnabled &&
        helpers_1.isAnyScheduleUnitConfigured(dailyScheduleModelValue.rows.third.schedule);
    const isWeeklyScheduleEnabled = weeklyScheduleModelValue.isEnabled &&
        helpers_1.isAnyScheduleUnitConfigured(weeklyScheduleModelValue.rows.third.schedule);
    const isMonthlyScheduleEnabled = monthlyScheduleModelValue.isEnabled &&
        helpers_1.isAnyScheduleUnitConfigured(monthlyScheduleModelValue.rows.third.schedule);
    const isYearlyScheduleEnabled = yearlyScheduleModelValue.isEnabled;
    if (isDailyScheduleEnabled) {
        let daysOfWeekList = [];
        if (dailyScheduleModelValue.fields.kind === types_1.DAILY_SCHEDULE_KINDS.everyday) {
            daysOfWeekList = helpers_1.getDaysOfWeekList();
        }
        if (dailyScheduleModelValue.fields.kind === types_1.DAILY_SCHEDULE_KINDS.weekDays) {
            const data = helpers_1.getDaysOfWeekList();
            data.pop(); // delete Sunday
            data.pop(); // delete Saturday
            daysOfWeekList = data;
        }
        if (dailyScheduleModelValue.fields.kind === types_1.DAILY_SCHEDULE_KINDS.selectedDays) {
            daysOfWeekList = dailyScheduleModelValue.fields.days;
        }
        if (modelValue.fieldDayNumberInMonthValue === types_1.HEALTH_CHECK_DAY_NUMBER_IN_MONTH.every) {
            return [...daysOfWeekList, types_1.HEALTH_CHECK_EXTENDED_DAY_OF_WEEK.scheduledDay];
        }
        return daysOfWeekList;
    }
    if (!isDailyScheduleEnabled && isWeeklyScheduleEnabled) {
        let daysOfWeekList = helpers_1.getListBy(weeklyScheduleModelValue.rows.third.schedule, helpers_1.getDaysOfWeekList());
        if (modelValue.fieldDayNumberInMonthValue === types_1.HEALTH_CHECK_DAY_NUMBER_IN_MONTH.every) {
            return [...daysOfWeekList, types_1.HEALTH_CHECK_EXTENDED_DAY_OF_WEEK.scheduledDay];
        }
        return daysOfWeekList;
    }
    if (!isDailyScheduleEnabled &&
        !isWeeklyScheduleEnabled &&
        isMonthlyScheduleEnabled &&
        monthlyScheduleModelValue.fields.dayNumberInMonth !== types_1.DAY_NUMBER_IN_MONTH.onDay) {
        return [monthlyScheduleModelValue.fields.dayOfWeek];
    }
    if (!isDailyScheduleEnabled &&
        !isWeeklyScheduleEnabled &&
        !isMonthlyScheduleEnabled &&
        isYearlyScheduleEnabled) {
        return [yearlyScheduleModelValue.fields.dayOfWeek];
    }
    return [];
};
HealthCheckHarmonizationManager.getMonthsData = (dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue, yearlyScheduleModelValue) => {
    const isDailyScheduleEnabled = dailyScheduleModelValue.isEnabled &&
        helpers_1.isAnyScheduleUnitConfigured(dailyScheduleModelValue.rows.third.schedule);
    const isWeeklyScheduleEnabled = weeklyScheduleModelValue.isEnabled &&
        helpers_1.isAnyScheduleUnitConfigured(weeklyScheduleModelValue.rows.third.schedule);
    const isMonthlyScheduleEnabled = monthlyScheduleModelValue.isEnabled &&
        helpers_1.isAnyScheduleUnitConfigured(monthlyScheduleModelValue.rows.third.schedule);
    const isYearlyScheduleEnabled = yearlyScheduleModelValue.isEnabled;
    if (isDailyScheduleEnabled || isWeeklyScheduleEnabled) {
        return [types_1.HEALTH_CHECK_MONTH_OF_YEAR.everyMonth];
    }
    if (!isDailyScheduleEnabled && !isWeeklyScheduleEnabled && isMonthlyScheduleEnabled) {
        return [types_1.HEALTH_CHECK_MONTH_OF_YEAR.everySelectedMonth];
    }
    if (!isDailyScheduleEnabled &&
        !isWeeklyScheduleEnabled &&
        !isMonthlyScheduleEnabled &&
        isYearlyScheduleEnabled) {
        return [yearlyScheduleModelValue.fields.month];
    }
    return helpers_1.getMonthsOfYearList();
};
HealthCheckHarmonizationManager.isDayOfWeekControlVisible = (modelValue, dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue, yearlyScheduleModelValue) => {
    const isDailyScheduleEnabled = dailyScheduleModelValue.isEnabled &&
        helpers_1.isAnyScheduleUnitConfigured(dailyScheduleModelValue.rows.third.schedule);
    const isWeeklyScheduleEnabled = weeklyScheduleModelValue.isEnabled &&
        helpers_1.isAnyScheduleUnitConfigured(weeklyScheduleModelValue.rows.third.schedule);
    const isMonthlyScheduleEnabled = monthlyScheduleModelValue.isEnabled &&
        helpers_1.isAnyScheduleUnitConfigured(monthlyScheduleModelValue.rows.third.schedule);
    const isYearlyScheduleEnabled = yearlyScheduleModelValue.isEnabled;
    if (!isDailyScheduleEnabled &&
        !isWeeklyScheduleEnabled &&
        isMonthlyScheduleEnabled &&
        monthlyScheduleModelValue.fields.dayNumberInMonth === types_1.DAY_NUMBER_IN_MONTH.onDay) {
        return false;
    }
    if (!isDailyScheduleEnabled &&
        !isWeeklyScheduleEnabled &&
        !isMonthlyScheduleEnabled &&
        isYearlyScheduleEnabled &&
        yearlyScheduleModelValue.fields.dayNumberInMonth === types_1.DAY_NUMBER_IN_MONTH.onDay) {
        return false;
    }
    return true;
};
HealthCheckHarmonizationManager.isDayOfMonthControlVisible = (modelValue, dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue, yearlyScheduleModelValue) => {
    const isDailyScheduleEnabled = dailyScheduleModelValue.isEnabled &&
        helpers_1.isAnyScheduleUnitConfigured(dailyScheduleModelValue.rows.third.schedule);
    const isWeeklyScheduleEnabled = weeklyScheduleModelValue.isEnabled &&
        helpers_1.isAnyScheduleUnitConfigured(weeklyScheduleModelValue.rows.third.schedule);
    const isMonthlyScheduleEnabled = monthlyScheduleModelValue.isEnabled &&
        helpers_1.isAnyScheduleUnitConfigured(monthlyScheduleModelValue.rows.third.schedule);
    const isYearlyScheduleEnabled = yearlyScheduleModelValue.isEnabled;
    if (modelValue.fieldDayNumberInMonthValue === types_1.HEALTH_CHECK_DAY_NUMBER_IN_MONTH.every) {
        return false;
    }
    if (!isDailyScheduleEnabled &&
        !isWeeklyScheduleEnabled &&
        isMonthlyScheduleEnabled &&
        monthlyScheduleModelValue.fields.dayNumberInMonth === types_1.DAY_NUMBER_IN_MONTH.onDay) {
        return true;
    }
    if (!isDailyScheduleEnabled &&
        !isWeeklyScheduleEnabled &&
        !isMonthlyScheduleEnabled &&
        isYearlyScheduleEnabled &&
        yearlyScheduleModelValue.fields.dayNumberInMonth === types_1.DAY_NUMBER_IN_MONTH.onDay) {
        return true;
    }
    return false;
};
HealthCheckHarmonizationManager.getResettedValues = (isBackupEnabled, healthCheckModelValue, dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue, yearlyScheduleModelValue) => {
    const modelValue = healthCheckModelValue;
    let isEnabled = modelValue.isEnabled;
    let dayNumberInMonth = modelValue.fieldDayNumberInMonthValue;
    let dayOfWeek = modelValue.fieldDayOfWeekValue;
    let dayOfMonth = modelValue.fieldDayOfMonthValue;
    let month = modelValue.fieldMonthValue;
    const isDailyScheduleEnabled = dailyScheduleModelValue.isEnabled &&
        helpers_1.isAnyScheduleUnitConfigured(dailyScheduleModelValue.rows.third.schedule);
    const isWeeklyScheduleEnabled = weeklyScheduleModelValue.isEnabled &&
        helpers_1.isAnyScheduleUnitConfigured(weeklyScheduleModelValue.rows.third.schedule);
    const isMonthlyScheduleEnabled = monthlyScheduleModelValue.isEnabled &&
        helpers_1.isAnyScheduleUnitConfigured(monthlyScheduleModelValue.rows.third.schedule);
    const isYearlyScheduleEnabled = yearlyScheduleModelValue.isEnabled;
    let isOnlyYearlyScheduleChanged = false;
    const dayNumberInMonthData = HealthCheckHarmonizationManager.getDayNumberInMonthData(dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue, yearlyScheduleModelValue);
    const dayOfWeekData = HealthCheckHarmonizationManager.getDayOfWeekData(modelValue, dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue, yearlyScheduleModelValue);
    const monthData = HealthCheckHarmonizationManager.getMonthsData(dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue, yearlyScheduleModelValue);
    if (!isDailyScheduleEnabled &&
        !isWeeklyScheduleEnabled &&
        !isMonthlyScheduleEnabled &&
        isYearlyScheduleEnabled) {
        const yearlyDayNumberInMonthValue = yearlyScheduleModelValue.fields.dayNumberInMonth;
        const yearlyDayOfWeekValue = yearlyScheduleModelValue.fields.dayOfWeek;
        const yearlyMonthValue = yearlyScheduleModelValue.fields.month;
        const yearlyDayOfMonthValue = yearlyScheduleModelValue.fields.dayOfMonth;
        isOnlyYearlyScheduleChanged =
            dayNumberInMonth !== yearlyDayNumberInMonthValue ||
                dayOfWeek !== yearlyDayOfWeekValue ||
                month !== yearlyMonthValue ||
                dayOfMonth !== yearlyDayOfMonthValue;
        dayNumberInMonth = yearlyScheduleModelValue.fields.dayNumberInMonth;
        dayOfWeek = yearlyScheduleModelValue.fields.dayOfWeek;
        month = yearlyScheduleModelValue.fields.month;
        dayOfMonth = yearlyScheduleModelValue.fields.dayOfMonth;
    }
    if (!dayNumberInMonthData.length ||
        (dayNumberInMonth &&
            dayNumberInMonthData.length > 0 &&
            !dayNumberInMonthData.includes(dayNumberInMonth))) {
        dayNumberInMonth = undefined;
    }
    if (!dayOfWeekData ||
        (dayOfWeek && dayOfWeekData.length > 0 && !dayOfWeekData.includes(dayOfWeek))) {
        dayOfWeek = undefined;
    }
    if (!monthData || (month && monthData.length > 0 && !monthData.includes(month))) {
        month = undefined;
    }
    if (!isDailyScheduleEnabled &&
        !isWeeklyScheduleEnabled &&
        isMonthlyScheduleEnabled &&
        monthlyScheduleModelValue.fields.dayNumberInMonth === types_1.DAY_NUMBER_IN_MONTH.onDay &&
        dayOfMonth !== monthlyScheduleModelValue.fields.dayOfMonth) {
        dayOfMonth = undefined;
    }
    const hasCancelledValues = dayNumberInMonth === undefined ||
        dayOfWeek === undefined ||
        month === undefined ||
        dayOfMonth === undefined ||
        isOnlyYearlyScheduleChanged;
    if (!dayNumberInMonth && dayNumberInMonthData.length === 1) {
        dayNumberInMonth = dayNumberInMonthData[0];
    }
    if (!dayOfWeek && dayOfWeekData.length === 1) {
        dayOfWeek = dayOfWeekData[0];
    }
    if (!month && monthData.length === 1) {
        month = monthData[0];
    }
    if (!dayOfMonth && monthlyScheduleModelValue.fields.dayOfMonth) {
        dayOfMonth = monthlyScheduleModelValue.fields.dayOfMonth;
    }
    if (!HealthCheckHarmonizationManager.isAvailable(isBackupEnabled, dailyScheduleModelValue, weeklyScheduleModelValue, monthlyScheduleModelValue, yearlyScheduleModelValue) ||
        hasCancelledValues) {
        isEnabled = false;
    }
    return Object.assign(Object.assign({}, modelValue), { isEnabled, fieldDayNumberInMonthValue: dayNumberInMonth, fieldDayOfWeekValue: dayOfWeek, fieldMonthValue: month, fieldDayOfMonthValue: dayOfMonth });
};
//# sourceMappingURL=HealthCheckHarmonizationManager.js.map